<template>
    <scrollBox
    :data="data" 
    :loading="loading"
    :total="total"
    :showMore="showMore"
    @loadMore="$emit('loadMore')">
        <template #left="scope">
            <audio-record v-if="scope.row.msgType == 'voice'" :src="scope.row.audioUrl" type="left"></audio-record>
            <file-record v-else-if="scope.row.msgType == 'file'" :url="scope.row.fileUrl" :title="fileName(scope.row.fileUrl)" :size="scope.row.fileSize || '未知'" :fileType="scope.row.fileExt" type="left"></file-record>
            <img-record v-else-if="scope.row.msgType == 'image' || scope.row.msgType == 'emotion'" :src="scope.row.imgUrl" type="left"></img-record>
            <text-record v-else :content="scope.row.contactText" type="left" ></text-record>
        </template>
        <template #right="scope">
            <audio-record v-if="scope.row.msgType == 'voice'" :src="scope.row.audioUrl" type="right"></audio-record>
            <file-record v-else-if="scope.row.msgType == 'file'" :url="scope.row.fileUrl" :title="fileName(scope.row.fileUrl)" :size="scope.row.fileSize || '未知'" :fileType="scope.row.fileExt" type="right"></file-record>
            <img-record v-else-if="scope.row.msgType == 'image' || scope.row.msgType == 'emotion'" :src="scope.row.imgUrl" type="right"></img-record>
            <text-record v-else :content="scope.row.contactText" type="right"></text-record>
        </template>
            </scrollBox>
</template>
<script>
import scrollBox from './lib/scroll-box.vue'
import scrollBox2 from './lib/scroll-box2.vue'
// import ScrollBox3 from './lib/Scroll-box3.vue'
import audioRecord from './lib/audio-record.vue'
import fileRecord from './lib/file-record.vue'
import imgRecord from './lib/img-record.vue'
import TextRecord from './lib/text-record.vue'
export default {
    components: { scrollBox,scrollBox2, audioRecord, fileRecord, imgRecord, TextRecord},
    props: {
        data: {
            type: Array,
            default() { return [] }
        },
        total: {
            type: Number,
            default() { return 0 }
        },
        loading: {
            type: Boolean,
            default() { return false }
        },
        showMore: {
            type: Boolean,
            default() { return false }
        }
    },
    computed: {
        fileName() {
            return function(url) {
                if(!url) return ''
                let index = url.lastIndexOf('/')
                return url.slice(index+1)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>